import {useMainStore} from "@/store";

const native = () => {
    const store = useMainStore();

    // Outside the local/testing environment, the web app has no access to registration.
    if (! store.isNative && ! store.isLocal && ! store.isTesting) {
        return {name: 'login'};
    }
};

export default native;
